import PropTypes from 'prop-types';
import { FormControl, MenuItem, Select } from '@mui/material';
import styles from '../SelectEditInputTextField/styles';

const MobileSelectEditValueTypes = (props) => {
  const { id, value, field, data, updateData, enableSort, loading } = props;
  const classes = styles();

  const handleChange = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    updateData(
      id,
      field,
      event.target.value,
    );
  };

  const isPlaceholder =
  loading && (value === null || value === undefined || value === '');

  return (
    <FormControl
      variant="filled"
      className={classes.inputField}
      sx={{ bgcolor: 'transparent' }}
    >
      <Select
        labelId={`signal-select-${id}`}
        id={`signal-select-${id}`}
        value={value}
         renderValue={(selected) => {
           if (isPlaceholder) {
             return '-';
           }
           return selected;
         }}
        onChange={handleChange}
        label={value}
        disableUnderline
        disabled={loading}
         sx={{
           '.MuiSelect-select': {
             p: '10px',
             fontWeight: 900
           },
         }}
      >
         {(enableSort ? [...data].sort((a, b) => a.localeCompare(b)) : data)?.map((item, idItem) => (
    <MenuItem key={`item_${item}_${idItem}`} value={item}>
      {item}
    </MenuItem>
         ))}
      </Select>
    </FormControl>
  );
};

MobileSelectEditValueTypes.propTypes = {
  field: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  value: PropTypes.any,
  data: PropTypes.any,
  updateData: PropTypes.func,
  closeCellAfterSelect: PropTypes.any,
  enableSort: PropTypes.any,
  loading: PropTypes.any
};

export default MobileSelectEditValueTypes;
